export function ChatbotIcon({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Speech bubble background */}
      <path
        d="M100 20C140 20 172 52 172 92C172 132 140 164 100 164C90 164 80 162 71 158L45 170L55 148C35 135 28 115 28 92C28 52 60 20 100 20Z"
        className="fill-teal-500"
      />
      {/* Robot head/body */}
      <rect x="60" y="65" width="80" height="60" rx="25" ry="25" fill="white" />
      {/* Robot antenna base */}
      <rect x="95" y="55" width="10" height="15" rx="2" fill="#E0E0E0" />
      {/* Robot antenna ball */}
      <circle cx="100" cy="50" r="6" fill="white" />
      {/* Robot visor/screen */}
      <rect x="70" y="75" width="60" height="25" rx="12" fill="#2C2C2C" />
      {/* Left eye */}
      <circle cx="85" cy="87" r="8" className="fill-teal-400" />
      <circle cx="85" cy="87" r="3" fill="#003D40" />
      {/* Right eye */}
      <circle cx="115" cy="87" r="8" className="fill-teal-400" />
      <circle cx="115" cy="87" r="3" fill="#003D40" />
      {/* Robot smile */}
      <path
        d="M90 110C95 115 105 115 110 110"
        stroke="#2C2C2C"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Robot arm/wave */}
      <rect x="140" y="100" width="25" height="8" rx="4" fill="white" transform="rotate(15 140 100)" />
      {/* Robot body extension */}
      <rect x="75" y="125" width="50" height="25" rx="12" fill="#F0F0F0" />
    </svg>
  );
}